module.exports = {
      id: "icon-twitter-usage",
      viewBox: "0 0 19.798 20.251",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-twitter",
      toString: function () {
        return this.url;
      }
    }